export type CertificationDocument = {
  rawFile?: File;
  src?: string;
  title?: string;
};

export type DocumentAssignee = {
  id: string;
  label: string;
};

export const buildDocumentsByAssetId = (
  documents: CertificationDocument[] = [],
  assignments: Record<string, string> = {},
): Record<string, CertificationDocument> => {

  const result: Record<string, CertificationDocument> = {};
  documents.forEach((doc, index) => {

    const assetId = assignments[String(index)];
    if (assetId && doc.rawFile) {

      result[assetId] = doc;

    }

  });
  return result;

};

export const validateBulkDocumentsUpload = (expectedCount: number) => (
  value: CertificationDocument[],
) => {

  const count = value?.length ?? 0;
  if (count !== expectedCount) {

    return 'resources.assets.certifications.text.bulk_documents_count_mismatch';

  }
  return undefined;

};

export const validateBulkAssignments = (
  assignments: Record<string, string> = {},
  recipients: DocumentAssignee[] = [],
): string | undefined => {

  const assignedIds = Object.values(assignments).filter(Boolean);
  const uniqueAssigned = new Set(assignedIds);

  if (uniqueAssigned.size !== assignedIds.length) {

    return 'resources.assets.certifications.text.bulk_documents_assignment_incomplete';

  }

  if (uniqueAssigned.size !== recipients.length) {

    return 'resources.assets.certifications.text.bulk_documents_assignment_incomplete';

  }

  return undefined;

};
